// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.menu[data-v-5c53f612] {

    position: fixed;

    inset: 0;

    bottom: 0;

    top: 5.75rem;

    z-index: 50;

    display: none;

    height: calc(100vh - 5.75rem);

    overflow-y: auto;

    --tw-bg-opacity: 1;

    background-color: rgb(251 212 76 / var(--tw-bg-opacity));

    padding: 2.5rem 3rem
}
@media (min-width: 996px) {
.menu[data-v-5c53f612] {

        position: static;

        display: flex;

        height: auto;

        flex-direction: row;

        align-items: center;

        gap: 1.5rem;

        overflow-y: visible;

        background-color: transparent;

        padding: 0
}
}
.menu__container--open .menu[data-v-5c53f612] {

    display: flex;

    flex-direction: column;

    justify-content: space-between
}
.menu__items[data-v-5c53f612] {

    display: flex;

    flex-direction: column;

    justify-content: space-between;

    gap: 2rem;

    font-family: Mont;

    line-height: 1.35;

    font-size: 1.375rem;

    font-weight: 700
}
@media (min-width: 996px) {
.menu__items[data-v-5c53f612] {

        display: flex;

        min-height: 100%;

        flex-direction: row;

        align-items: center;

        gap: 0;

        padding-left: 0.375rem;

        padding-right: 0.375rem;

        padding-top: 0;

        padding-bottom: 0;

        font-family: Roboto;

        line-height: 1.5;

        font-size: 0.875rem;

        font-weight: 700
}
}
.menu__item[data-v-5c53f612]:hover {

    cursor: pointer
}
.menu__link[data-v-5c53f612] {

    display: flex;

    align-items: center;

    justify-content: space-between;

    gap: 0.5rem;

    text-transform: uppercase
}
@media (min-width: 996px) {
.menu__link[data-v-5c53f612] {

        padding-left: 1rem;

        padding-right: 1rem;

        padding-top: 2rem;

        padding-bottom: 2rem
}
}
.menu__item:hover .menu__link[data-v-5c53f612] {

    --tw-text-opacity: 1;

    color: rgb(200 143 0 / var(--tw-text-opacity))
}
.menu__moles[data-v-5c53f612] {

    left: -14rem;

    bottom: -2.5rem;

    z-index: -1;

    --tw-scale-x: .9;

    --tw-scale-y: .9;

    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

    opacity: 0.6
}
@media (min-width: 640px) {
.menu__moles[data-v-5c53f612] {

        bottom: 0;

        left: -10rem;

        --tw-scale-x: 1;

        --tw-scale-y: 1;

        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
}
@media (min-width: 996px) {
.menu__moles[data-v-5c53f612] {

        display: none
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/menus/Menu.vue"],"names":[],"mappings":";AAoEA;;IAAA,eAAA;;IAAA,QAAA;;IAAA,SAAA;;IAAA,YAAA;;IAAA,WAAA;;IAAA,aAAA;;IAAA,6BAAA;;IAAA,gBAAA;;IAAA,kBAAA;;IAAA,wDAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,gBAAA;;QAAA,aAAA;;QAAA,YAAA;;QAAA,mBAAA;;QAAA,mBAAA;;QAAA,WAAA;;QAAA,mBAAA;;QAAA,6BAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,aAAA;;IAAA,sBAAA;;IAAA;AAAA;AAIA;;IAAA,aAAA;;IAAA,sBAAA;;IAAA,8BAAA;;IAAA,SAAA;;IAAA,iBAAA;;IAAA,iBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,aAAA;;QAAA,gBAAA;;QAAA,mBAAA;;QAAA,mBAAA;;QAAA,MAAA;;QAAA,sBAAA;;QAAA,uBAAA;;QAAA,cAAA;;QAAA,iBAAA;;QAAA,mBAAA;;QAAA,gBAAA;;QAAA,mBAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA;AAAA;AAGA;;IAAA,aAAA;;IAAA,mBAAA;;IAAA,8BAAA;;IAAA,WAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,kBAAA;;QAAA,mBAAA;;QAAA,iBAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,oBAAA;;IAAA;AAAA;AAKA;;IAAA,YAAA;;IAAA,eAAA;;IAAA,WAAA;;IAAA,gBAAA;;IAAA,gBAAA;;IAAA,+LAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,SAAA;;QAAA,YAAA;;QAAA,eAAA;;QAAA,eAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA","sourcesContent":["<template>\n  <div class=\"menu__container\" :class=\"{ 'menu__container--open': display }\">\n    <MobileMenuIcons v-model=\"display\" />\n    <nav class=\"menu\">\n      <ul class=\"menu__items\">\n        <li v-for=\"(value, key) in elements\" :key=\"key\" class=\"menu__item\">\n          <SubMenu v-if=\"Array.isArray(value)\" :name=\"key\" :elements=\"value\" />\n          <a v-else class=\"menu__link\" :href=\"value\">\n            {{ key }}\n          </a>\n        </li>\n      </ul>\n      <Contact />\n      <Moles :count=\"1\" background=\"transparent\" align=\"right\" class=\"menu__moles\" :scale=\"2.25\" reversed />\n    </nav>\n  </div>\n</template>\n\n<script>\nimport { ref, toRefs, watch } from '@vue/composition-api';\nimport { Link } from '@inertiajs/inertia-vue';\nimport { onMinWidth } from '@/lego/utils/window/screen';\nimport Contact from '@/lego/partials/Contact.vue';\nimport SubMenu from '@/lego/components/menus/SubMenu.vue';\nimport MobileMenuIcons from '@/lego/components/menus/MobileMenuIcons.vue';\nimport Moles from '@/lego/components/layout/Moles.vue';\n\nexport default {\n  components: {\n    Link,\n    Contact,\n    SubMenu,\n    MobileMenuIcons,\n    Moles,\n  },\n  props: {\n    value: {\n      type: Boolean,\n      default: false,\n    },\n    elements: {\n      type: Object,\n      required: true,\n    },\n  },\n  setup(props, { emit }) {\n    const { value } = toRefs(props);\n    const display = ref(value.value);\n\n    watch(value, val => (display.value = val));\n\n    watch(display, val => {\n      emit('input', val);\n    });\n\n    onMinWidth(996, function(event) {\n      display.value = false;\n    });\n\n    return {\n      display,\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n.menu {\n  @apply fixed inset-0 bottom-0 z-50 squish-sm lg:p-0 hidden overflow-y-auto lg:overflow-y-visible lg:flex lg:flex-row lg:gap-xxs lg:items-center bg-brand-primary-light lg:bg-transparent lg:static top-[5.75rem] h-[calc(100vh-5.75rem)] lg:h-auto;\n\n  .menu__container--open & {\n    @apply flex flex-col justify-between;\n  }\n\n  &__items {\n    @apply flex flex-col style-subtitle-sm-bold lg:style-overline-bold gap-xs lg:gap-0 lg:flex-row lg:items-center justify-between lg:min-h-full lg:flex lg:px-[0.375rem] lg:py-0;\n  }\n  &__item {\n    @apply hover:cursor-pointer;\n  }\n  &__link {\n    @apply uppercase flex items-center justify-between gap-nano lg:px-xxxs lg:py-xs;\n\n    .menu__item:hover & {\n      @apply text-brand-primary-darkest;\n    }\n  }\n\n  &__moles {\n    @apply lg:hidden -left-[14rem] -bottom-sm sm:bottom-0 sm:-left-huge scale-90 sm:scale-100 opacity-60 -z-[1];\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
